<template>
  <div class="flex xs-10 xs-center">
    <h1>Thank You</h1>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'thank-you'
}
</script>



// WEBPACK FOOTER //
// src/components/ThankYou.vue